import SectionTitlePresentation from 'components/SectionTitle/SectionTitlePresentation'

export default {
  Presentation: SectionTitlePresentation,
}
